module.exports = __webpack_public_path__ + "media/images/guideline/coupon-01-22c8bcc4658a7c62bec69a049236fee1.jpg";